<ng-container *ngIf="objectIdentifier && initialized">

  <cr-customer-header-consultant
    [customerId]="objectIdentifier.objectId"
    (customerDtoChange)="handleCustomerDto($event)"
  ></cr-customer-header-consultant>

  <!--
      TM-1000002005: the restriction is now a THREE-state gate. The two `restricted` arms below are
      this page's own inlined copy of <mvs-restricted-banner> and stay exactly as they were; the new
      `do_not_call` arm is advisory and therefore has no second arm - there is no lock to be in or
      out of.

      The gate in the TS (cr-customer-object-consultant.page.ts, in getCustomerName()) MUST STAY
      binary-`restricted`: it renders no banner, it triggers retrieveCustomerRestrictionLog(), which
      sets `restrictedProfile`, which masks data. `do_not_call` must never reach it.
  -->
  @if (customerDto?.customerTypeDto?.restrictionType == CrCustomerRestrictionType.restricted) {


    @if (restrictedProfile) {

      <div class="mb-2 px-4 bg-red-100 border-1 border-red-500 py-3 border-round-lg">
        <div class="text-red-700 flex justify-content-between">
          <div class="flex align-items-center  gap-2">
            <i class="pi pi-ban text-2xl text-red-700"></i>
            <span>Achtung: Dies ist ein Sperrkunde. Keine Kontaktaufnahme oder Verarbeitung erlaubt.</span>
          </div>
          <div class="flex align-items-center gap-2 cursor-pointer" (click)="unlockProfile()">
            <i class="pi pi-lock text-2xl text-primary"></i>
            <span
              class="text-primary font-medium">Eingeschränkte Daten entsperren</span>
          </div>
        </div>
      </div>
    } @else {
      <div class="mb-2 px-4 bg-red-100 border-1 border-red-500 py-3 border-round-lg">
        <div class="text-red-700 flex justify-content-between">
          <div class="flex align-items-center  gap-2">
            <i class="pi pi-ban text-2xl text-red-700"></i>
            <span>Achtung: Dies ist ein Sperrkunde. Keine Kontaktaufnahme oder Verarbeitung erlaubt. Die Daten werden nach Abmeldung oder Inaktivität automatisch wieder gesperrt.</span>
          </div>
          <div class="flex align-items-center gap-2 cursor-pointer">
            <i class="pi pi-lock-open text-2xl text-primary"></i>
          </div>
        </div>
      </div>
    }
  } @else if (customerDto?.customerTypeDto?.restrictionType == CrCustomerRestrictionType.do_not_call) {

    <mvs-advisory-banner></mvs-advisory-banner>

  }

  <!--Customer Filters -->
  <div class="flex mt-1 mb-2" *ngIf="customerFilter.length > 0 && viewType == 0">

    <div class="col-12 flex">
      <h3 class="mb-0">{{ customerName }}</h3>

      <div class="flex align-items-center mx-4 gap-2 flex-wrap">
        <p-chip
          *ngFor="let filter of customerFilter"
          [label]="filter.field"
          [removable]="true"
          (onRemove)="onRemoveFilterCriteria(filter)"
        ></p-chip>
      </div>

    </div>

  </div>

  @if (customerDto && !restrictedProfile) {

    <!-- Show Object -->
    <mvs-cr-customer-consultant [objectIdentifier]="objectIdentifier"
                     [changedFilter]="changedFilter"
                     [viewType]="viewType"
                     [customerRelatedPersonWidgetStyle]="customerRelatedPersonWidgetStyle"
                     (onChangeCustomerFilter)="handleCustomerFilter($event)"
    ></mvs-cr-customer-consultant>

  } @else if (restrictedProfile) {
    <div class=" h-full w-full flex flex-column justify-content-center align-items-center pt-8">
      <i class="pi pi-lock text-300 " style="font-size: 200px"></i>
      <p class="text-2xl">Eingeschränkte Daten </p>
    </div>
  }


</ng-container>


<p-button type="button" (click)="openSidebar()" icon="pi pi-link text-2xl" *ngIf="!displaySidebar"
          class="layout-config-button"></p-button>
<p-drawer
  #sidebar
  [(visible)]="displaySidebar"
  [position]="'right'"
  [blockScroll]="false"
  [showCloseIcon]="false"
  [baseZIndex]="1000"
  [styleClass]="'layout-rightmenu p-sidebar-sm fs-small p-3 w-30rem'"
>
  <ng-container *ngIf="displaySidebar">
    <external-partner-link
      [customerId]="objectIdentifier.objectId"
    ></external-partner-link>
    <cw-application-launch
      [customerId]="objectIdentifier.objectId"
    ></cw-application-launch>
  </ng-container>
</p-drawer>


<p-dialog [header]="'Eingeschränkte Daten entsperren?'" [(visible)]="unlockReasonDialog" [style]="{width: '700px'}">
  <div class="">
    Diese Aktion wird im System protokolliert und erfordert eine Begründung.
    Bitte gib den Grund für das Entsperren an.
  </div>
  <div class="mt-4">
    Grund für das Entsperren<span class="text-red-700">*</span>
    <div class="w-full">
      <textarea type="text" pInputText class="w-full" [(ngModel)]="unlockReason"></textarea>
    </div>
    <div class="bg-yellow-100 border-1 border-yellow-500 py-3 border-round-lg mt-2">
      <div class="flex align-items-center text-orange-900 gap-2 px-3">
        <i class="fa-regular fa-triangle-exclamation text-2xl"></i>
        <span class="">Der Zugriff endet, wenn du den Tab schließt, dich abmeldest oder die Sitzung abläuft.</span>
      </div>
    </div>
    <div class="mt-4 flex justify-content-end gap-3">
      <p-button [link]="true" (click)="unlockReasonDialog = false"> Abbrechen</p-button>
      <p-button [disabled]="(unlockReason.trim()).length == 0" (click)="unlockCustomer()"> Daten entsperren
      </p-button>
    </div>
  </div>
</p-dialog>

